import { render } from "./OrganizerCertificateMigrationDrawer.vue?vue&type=template&id=66329f47&scoped=true"
import script from "./OrganizerCertificateMigrationDrawer.vue?vue&type=script&lang=js"
export * from "./OrganizerCertificateMigrationDrawer.vue?vue&type=script&lang=js"

import "./OrganizerCertificateMigrationDrawer.vue?vue&type=style&index=0&id=66329f47&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66329f47"]])

export default __exports__